export default "__VITE_ASSET__C5a9vEfd__"